import SidebarContents from './SidebarContents';

export default SidebarContents;
